<template>
  <div class="review-rule">
    <div class="layout-content">
      <SubTitle class="title" :text="data.title" />

      <div class="main">
        <div class="module" v-for="(item, i) in data.main" :key="i">
          <div class="title-wrap" :style="{ '--bg-color': `rgba(${item.titleBgColor}, 0.2)`, height: isMobile && item.type === 'ai' ? '180px' : (isMobile ? '234px' : 'auto') }">
            <img class="module-logo" :src="item.titleImg" alt="">
            <div class="module-title" :style="{ '--font-color': item.titleColor }">{{ !isMobile ? item.title : item.titleMobile }}</div>
          </div>
          <ul class="module-lists">
            <li class="module-list" v-for="(item, j) in item.list" :key="j">
              <div class="percent">{{item.percent}}</div>
              <div class="right">
                <div class="rule-title">{{item.title}}</div>
                <div class="rule-desc">{{item.desc}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubTitle from '@/components/SubTitle'

export default {
  props: ['data'],
  data () {
    return {

    }
  },
  components: {
    SubTitle
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  }
}
</script>

<style lang="scss" scoped>
.review-rule {
  padding: 120px 0 120px;
  background: #F7F8FA;

  @include mobile {
    padding: 40px 0 50px;
  }
}

.title {
  @include mobile {
    margin-bottom: 0;
  }
}

.main {
  position: relative;
  display: flex; justify-content: space-between;

  @include mobile {
    display: block;
    margin-top: 5px;
  }
}

.module {
  width: 384px; height: 523px;
  padding: 44px 60px 75px 42px;
  background: #FFFFFF;

  @include mobile {
    display: flex; align-items: center;
    width: 100%; height: auto;
    margin-bottom: 20px;
    padding: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.module-logo {
  width: 62px; height: 62px;
  margin-bottom: 40px;

  @include mobile {
    width: 48px; height: 48px;
    // margin-bottom: 12px;
    margin-bottom: 0;
  }
}

.title-wrap {
  @include mobile {
    flex: none;
    display: flex; flex-direction: column; align-items: center;
    width: 48px; height: 180px;
    margin-right: 40px;
    background: var(--bg-color);
  }
}

.module-title {
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: 600; line-height: 40px;
  color: var(--font-color);

  @include mobile {
    width: 16px;
    margin: auto;
    font-size: 16px;
    line-height: 26px;
  }
}

.percent {
  margin-right: 60px;
  color: #000000;
  font-size: 30px;
  font-family: DIN-BlackItalic, DIN;
  line-height: 37px;

  @include mobile {
    margin-right: 34px;
    font-size: 20px;
    line-height: 24px;
  }
}

.module-list {
  display: flex; align-items: center;
  margin-bottom: 24px;

  @include mobile {
    margin-bottom: 24px;
    line-height: 21px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.right {
  padding-top: 5px;
}

.rule-title {
  margin-bottom: 13px;
  color: #2F3030;
  line-height: 25px;
  font-size: 18px; font-weight: 400;

  @include mobile {
    margin-bottom: 0;
    font-size: 15px;
    letter-spacing: 1px;
  }
}

.rule-desc {
  @include font(18, 400);
  line-height: 32px;
}

</style>
